import { takeLatest } from 'redux-saga/effects';
import { MODULE_NAME } from '../constants';
import { LOAD_MONITOR_LIST } from '../actions';

import loadMonitorList from './loadMonitorList';

export default function* sagas() {
  yield takeLatest(MODULE_NAME + LOAD_MONITOR_LIST, loadMonitorList);
}
